import { useState, type InputHTMLAttributes } from 'react';

import LucideSymbolIcon from '../icons/LucideSymbolIcon';

const inputClass =
  'w-full rounded-lg border-none bg-surface-container-high py-2 pl-10 pr-10 text-sm text-on-surface placeholder:text-outline focus:outline-none focus:ring-0 sm:py-2.5 sm:pl-11 sm:pr-11';

type AuthPasswordInputProps = {
  label: string;
  className?: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export default function AuthPasswordInput({
  label,
  className = '',
  id,
  ...inputProps
}: AuthPasswordInputProps) {
  const [visible, setVisible] = useState(false);
  const inputId = id ?? inputProps.name;

  return (
    <label className={`block space-y-1 ${className}`} htmlFor={inputId}>
      <span className="text-xs font-bold text-on-surface-variant">{label}</span>
      <div className="relative rounded-lg border border-transparent focus-glow">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2">
          <LucideSymbolIcon name="lock" tone="muted" size={18} />
        </span>
        <input
          {...inputProps}
          id={inputId}
          type={visible ? 'text' : 'password'}
          className={inputClass}
        />
        <button
          type="button"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-lg p-1 text-on-surface-variant transition hover:text-primary"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          tabIndex={-1}
        >
          <LucideSymbolIcon name={visible ? 'visibility_off' : 'visibility'} tone="inherit" size={18} />
        </button>
      </div>
    </label>
  );
}
